export function useEnvLabel(): { label: string; color: string } {
  const env = (import.meta.env as unknown as { VITE_ENV_LABEL?: string })?.VITE_ENV_LABEL ?? 'DEV';
  const label = String(env).toUpperCase();
  const color = label === 'PROD' ? 'red' : label === 'STAGE' ? 'gold' : 'blue';
  return { label, color };
}
